/**
 * Uses the Google favicon API to get the logo of the website
 */
export const getLogoFromWebsite = (website: string, size = 64): string | undefined => {
    if (!website) {
        return undefined;
    }
    // strip off protocol, API doesn't like it
    website = website?.replace(/(^\w+:|^)\/\//, "");
    // clean off any path & query string
    website = website?.replace(/\/.*/, "");

    const url = `https://www.google.com/s2/favicons?sz=${size}&domain=${website}`;
    return url;
};
